import { entries } from 'd3-collection';
import { intcomma } from 'journalize';

import formatPercent from './format-percent';
import sumValues from './sum-values';

const tooltipGenerator = (county, candidateMap, colorMap) => {
  const sortedResults = entries(county.results).sort(
    (a, b) => b.value - a.value
  );

  const firstThreeResults = sortedResults.slice(0, 3);

  const candidates = firstThreeResults
    .map(cand => {
      const candidate = candidateMap.get(cand.key);

      return `
      <tr class="candidate contest__candidate-row">
        <td class="candidate__cell candidate__party">
          <span class="pill-circle pill--${candidate.party.slice(
            0,
            3
          )}" style="background-color: ${colorMap.get(cand.key)};"></span>
        </td>
        <td class="candidate__cell candidate__name">
          ${candidate.ballot_sort_name}
        </td>
        <td class="candidate__cell candidate__votes">
          ${intcomma(county.results[cand.key])}
        </td>
        <td class="candidate__cell candidate__pct">
          ${formatPercent(
            county.results[cand.key],
            county.total_votes
          )}<span class="candidate__pct-symbol">%</span>
        </td>
      </tr>
    `;
    })
    .join('');

  return `
  <div class="contest">
    <table class="contest__candidates contest__candidates--tooltip">
      <caption>
        <p class="contest__title">${county.county} County</p>
        <div class="contest__metrics">
          <p class="contest__precincts">${county.precincts_reporting} of ${
    county.total_precincts
  } precincts reporting (${formatPercent(
    county.precincts_reporting,
    county.total_precincts
  )}%)</p>
        </div>
      </caption>
      <thead>
        <tr>
          <th class="contest__candidate-header" colspan="2">Candidate</th>
          <th class="contest__candidate-header contest__candidate-header--numeric">Votes</th>
          <th class="contest__candidate-header contest__candidate-header--numeric">Pct.<span class="candidate__pct-symbol">%</span></th>
        </tr>
      </thead>
      <tbody>
        ${candidates}
      </tbody>
    </table>
  </div>
  `;
};

export default tooltipGenerator;



// WEBPACK FOOTER //
// ./utils/tooltip-generator.js